import { ProductItem } from "../product-item/product-item";

export default new class ProductSlider extends ProductItem {
    constructor() {
        super();
        this.slider = '.fs-product-slider';

        if (!document.querySelector(this.slider)) return;

        this.sliderList = '.fs-product-slider--list';

        this.classShow = 'fs--show';       

        this.eventsHandler();
        this.initSlider();
        this.attachEvents();
    }

    eventsHandler() {
        $(this.sliderList).on('init', e => $(e.currentTarget).addClass(this.classShow));
        $(this.sliderList).on('afterChange', this.attachEvents);
    }

    attachEvents = () => {
        document.querySelectorAll(this.favoriteIcon).forEach(icon => {
            icon.addEventListener('click', this.handleOnFavoriteIconClick)
        })

        document.querySelectorAll(this.addIcon).forEach(icon => {
            icon.addEventListener('click', this.handleOnAddIconClick)
        })
    }

    initSlider() {
        $(this.sliderList).slick({
            dots: false,
            infinite: true,
            speed: 500,
            slidesToScroll: 1,
            accessibility: false,
            variableWidth: true,
            autoplay: true,
            autoplaySpeed: 3000,
        })
    }
}